import { motion, useMotionValue, useTransform, useInView, animate } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import "./AnimatedCounter.css";

interface AnimatedCounterProps {
  value: number; // tipo explícito
}

const AnimatedCounter: React.FC<AnimatedCounterProps> = ({ value }) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  const motionValue = useMotionValue(0);
  const rounded = useTransform(motionValue, (latest) => Math.round(latest));
  const [count, setCount] = useState(0);

  useEffect(() => {
    const unsubscribe = rounded.onChange((v) => setCount(v));

    if (isInView) {
      animate(motionValue, value, { duration: 2, ease: "easeOut" });
    }

    return () => unsubscribe();
  }, [isInView, motionValue, rounded, value]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={isInView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.05, ease: "easeOut" }}
      className="text-3xl font-bold text-blue-600"
    >
      +{count.toLocaleString()}
    </motion.div>
  );
};

export default AnimatedCounter;
